import styled from 'styled-components';

// import { ButtonBig } from '../layout/Button';
// import RadioButton from './RadioButton';
import Icon from '@/ui/components/Icon';

export const DisplayedAfterVoting = styled.div`
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media screen and (min-width: 768px) {
    max-width: 40rem;
  }
`;

export const CloseIcon = styled(Icon)`
  position: absolute;
  top: 1rem;
  right: 1rem;
  color: #acacac;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.custom.colors.black};
  }
`;

export const Thumb = styled.div<{ $active?: boolean }>`
  cursor: pointer;

  &:last-child {
    position: relative;
    top: 0.4rem;
  }

  svg {
    width: 2rem;
    height: auto;
    max-width: none;

    &:hover {
      opacity: 0.8;
      stroke: ${({ theme }) => theme.custom.colors.brand};
    }

    ${({ $active, theme }) =>
      $active &&
      `
      &:first-child {
        position: relative;
        top: 1px;
      }

      fill: ${theme.custom.colors.brand};
      stroke: transparent !important;
    `}
  }
`;

export const FormWrapper = styled.div<{ $unfolded: boolean }>`
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  padding: 3rem 1rem 0rem 1rem;
  margin: 2rem 1rem 0 1rem;
  border-top: 1px solid #e0e0e0;

  ${({ $unfolded }) =>
    $unfolded &&
    `
    background: ${props => props.theme.palette.gray.light};
  `}

  ${DisplayedAfterVoting} {
    display: ${({ $unfolded }) => ($unfolded ? 'flex' : 'none')};
  }

  ${CloseIcon} {
    display: ${({ $unfolded }) => ($unfolded ? 'block' : 'none')};
  }

  ${Thumb} {
    stroke: ${({ $unfolded, theme }) => ($unfolded ? '#7a7a7a' : theme.custom.colors.black)};
  }

  @media screen and (max-width: 1024px) {
    margin-left: 0;
    width: 100%;
  }
`;

export const Thumbs = styled.div<{ disabled?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  width: 2rem;
  padding: 2rem 0 1rem 0;

  svg {
    width: 2rem;
    height: auto;
  }

  ${({ disabled }) =>
    disabled &&
    `
  ${Thumb} {
    cursor: not-allowed;
    stroke: #7a7a7a;

    svg {
      &:hover {
        stroke: #7a7a7a;
    }
  `}
`;

export const OrangeText = styled.span`
  color: ${({ theme }) => theme.custom.colors.brand};
  padding: 1rem 0;
`;

export const OrangeTextThanks = styled(OrangeText)`
  margin-bottom: 2rem;
`;

export const RadioButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 1rem;
  padding: 1rem 0;
  flex-wrap: wrap;
  border-radius: 0.15rem;
`;

export const Textarea = styled.textarea`
  width: 100%;
  height: 6rem;
  margin: 1rem 0;
  border-radius: 0.15rem;
  border: 1px solid #b3b3b3;
  padding: 0.5rem;
`;

export const ControlButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 5rem;
  padding: 0.5rem 0 2rem 0;
`;

// export const FeedbackFromButtonBig = styled(ButtonBig)`
//   border-radius: 0.15rem;
//   text-transform: none;
//   font-size: 1rem;
//   padding: 0rem 1.5rem 0rem 1.5rem !important;
//   height: 3rem;
// `;

// export const SubmitButton = styled(FeedbackFromButtonBig)`
//   &:disabled {
//     cursor: not-allowed;
//     opacity: 0.6;
//     background: ${({ theme }) => theme.custom.colors.brand} !important;

//     &:hover {
//       background: ${({ theme }) => theme.custom.colors.brand} !important;
//     }
//   }
// `;

// export const CancelButton = styled(FeedbackFromButtonBig)`
//   color: ${({ theme }) => theme.custom.colors.black};
//   background: transparent;
//   border: 1px solid ${({ theme }) => theme.custom.colors.black};

//   &:hover {
//     background: #b3b3b3 !important;
//   }
// `;

export const ErrorMessage = styled.div`
  color: red;
`;

export const Notice = styled.div<{ open: boolean }>`
  position: absolute;
  top: 9rem;
  display: ${({ open }) => (open ? `block` : `none`)};
  background: ${props => props.theme.palette.gray.light};
  padding: 1rem;
  text-align: center;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.2);

  &:before {
    content: '';
    position: absolute;
    top: -0.5rem;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 1rem solid transparent;
    border-right: 1rem solid transparent;
    border-bottom: 1rem solid #f5f5f5;
  }
`;

export const FeedbackWrapper = styled.div`
  display: flex;
  justify-content: end;
`;

export const Placeholder = styled.div`
  display: inline-block;
  width: 275px;
  height: auto;

  @media screen and (max-width: 1020px) {
    display: none;
  }
`;
